module.exports = __webpack_public_path__ + "static/media/gamificacion.e4d58431.png";